import { useEffect } from 'react';
import { toast } from 'sonner';

const SEQUENCE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
];

/**
 * Konami code easter egg — brief robot celebration toast.
 */
export function useKonamiCode() {
  useEffect(() => {
    let index = 0;

    const onKeyDown = (e) => {
      // Certains events (IME, autofill, outils a11y) peuvent omettre e.key
      if (typeof e.key !== 'string') return;

      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      const expected = SEQUENCE[index];
      if (typeof expected !== 'string') {
        index = 0;
        return;
      }
      const expectedKey = expected.length === 1 ? expected.toLowerCase() : expected;

      if (key === expectedKey) {
        index += 1;
        if (index >= SEQUENCE.length) {
          index = 0;
          document.body.classList.add('robot-mode-active');
          toast('Mode robot activé !', {
            description: 'Bip-bip ! Bienvenue dans l\'univers DigiRobot.',
            duration: 4000,
          });
          window.setTimeout(() => {
            document.body.classList.remove('robot-mode-active');
          }, 3000);
        }
      } else {
        const first = SEQUENCE[0];
        const firstKey =
          typeof first === 'string' && first.length === 1 ? first.toLowerCase() : first;
        index = key === firstKey ? 1 : 0;
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
}
